<template>
  <div class="wraper">
    <div class="block" style="float:left">
      <i class="el-icon-goods">分类管理</i>
    </div>
    <div class="block" style="float:right;margin-bottom:10px">
      <el-input v-model="search"  style="width:200px" size="mini" placeholder="请输入搜索内容"  clearable @keyup.enter.native="searchTable"></el-input>
      <el-button @click="searchTable"size="mini" type="primary">搜索</el-button>
      <el-button @click="handleAdd" size="mini" type="primary">新增</el-button>
      <el-button @click="exportTable"size="mini"  type="primary">导出报表</el-button>
    </div>
  <el-table
    ref="filterTable"
    :data="tableData"
    style="width: 100%">
    <el-table-column
      prop="id"
      label="序号"
    >
    </el-table-column>
    <el-table-column
      prop="className"
      label="商品分类"
      >
    </el-table-column>
    <el-table-column
      prop="createTime"

      label="创建时间">
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button
          size="mini"
          @click="handleEdit(scope.$index, scope.row)">修改
        </el-button>
        <el-button
          size="mini"
          type="danger"
          @click="handleDelete(scope.$index, scope.row)">删除
        </el-button>
      </template>
    </el-table-column>
  </el-table>
    <div>
      <el-dialog title="新增商品分类" :visible.sync="dialogAddVisible" center   width="30%">
        <el-form :model="addform" >
          <el-form-item label="分类名称" :label-width="formLabelWidth" >
            <el-input v-model="addform.className"  style="width:220px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearForm">取 消</el-button>
          <el-button type="primary" @click="addGoods">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="编辑商品分类" :visible.sync="dialogFormVisible" center   width="30%">
        <el-form :model="form" >
          <el-form-item label="分类名称" :label-width="formLabelWidth" >
            <el-input v-model="form.className"  style="width:220px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearForm">取 消</el-button>
          <el-button type="primary" @click="editGoods">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  <div style="text-align: center;margin-top: 30px;">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableData: [],
      options: [],
      total: 0,
      pagesize: 10,
      currentPage: 1,
      search : "",
      dialogAddVisible: false,
      dialogFormVisible: false,
      form: {
        id :'',
        className: ''
      },
      addform:{
        className:''
      },
      formLabelWidth: '100px'
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData(){
      var param = {pageSize : this.pagesize, pageNum : this.currentPage}
      if (this.search !="") {
        param.search = this.search
      }
      // get
      this.$ajax.get('data/goods/goodsClassList', {
        params: param
      }).then((res) => {
        var data = res.data.data
        this.total = data.total
        this.tableData = data.list
        this.pagesize = data.pageSize
      }).catch((err) => {
        this.$message.error('请求goods失败')
      })
    },
    searchTable(){
      this.getData()
    },
    formatter (row, column) {
      return row.address
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.getData()
    },
    handleCurrentChange: function(currentPage){
      this.currentPage = currentPage;
      this.getData()
    },
    exportTable : function () {
      var list;
      var param = {pageSize : 10000, pageNum : 1}
      this.$ajax.get('data/goods/goodsClassList', {
        params: param
      }).then((res) => {
        list = res.data.data.list
      }).catch((err) => {
        this.$message.error('请求goodsClass失败')
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../vendor/Export2Excel');
        const tHeader = ["序号", "商品分类", "创建时间"];
        const filterVal = ["id","className","createTime"];
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '商品分类');
      })
    },
    formatJson :function(filterVal, jsonData){
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
    clearForm :function(){
      this.form={}
      this.addform ={}
      this.dialogFormVisible = false
      this.dialogAddVisible = false
    },
    handleAdd :function () {
      this.addform ={}
      this.dialogAddVisible = true
    },
    addGoods : function(){
      this.$confirm('此操作将新增商品分类信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.post('data/goods/addGoodsClass', {
          className: this.addform.className
        }).then((res) => {
          if (res.data.code == 200){
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.clearForm()
            this.getData()
          } else{
            this.$message.error(res.data.msg);
          }
        }).catch((err) => {
          this.$message.error('请求失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    },
    handleEdit :function (index ,row ) {
      this.form = {
        id:'',
        className:''
      }
      this.form.id = row.id;
      this.form.className = row.className
      this.dialogFormVisible = true
    },
    editGoods :function(){
      this.$confirm('此操作将修改商品分类信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.post('data/goods/editGoodsClass', {
          id: this.form.id,
          className: this.form.className
        }).then((res) => {
          if (res.data.code == 200){
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.clearForm()
            this.getData()
          } else{
            this.$message.error(res.data.msg);
          }
        }).catch((err) => {
          this.$message.error('请求失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    },
    handleDelete : function (index ,row ) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.post('data/goods/deleteGoodsClass', {
          id: row.id
        }).then((res) => {
          if (res.data.code == 200){
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.getData()
          } else{
            this.$message.error(res.data.msg);
          }
        }).catch((err) => {
          this.$message.error('请求失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<style scoped>
  body {
    margin: 0;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/goodsClass.vue